import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { IReducerState, history } from 'store/main-reducer';
import {
  getIsCalcOnly,
  getIsAccountant,
} from 'store/modules/sign-up/selectors';
import { getHasLoadedOptions } from 'store/modules/options/selectors';
import { NextStepsView, IStep } from './NextSteps';

interface Props {
  intl: IntlShape;
  isCalcOnly: boolean;
  hasLoadedOptions: boolean;
  isAccountant: boolean;
}

export const NextStepsController = (props: Props) => {
  const {
    intl, hasLoadedOptions, isCalcOnly, isAccountant,
  } = props;

  if (!hasLoadedOptions) {
    history.push('/');
    return null;
  }

  const header = intl.formatMessage({ id: isAccountant ? 'GETTING_YOU_SET_UP_ACCOUNTANT' : 'GETTING_YOU_SET_UP' });

  const steps: IStep[] = [
    {
      title: intl.formatMessage({ id: 'FIRST_STEP_TITLE' }),
      text: intl.formatMessage({
        id: isAccountant ? 'FIRST_STEP_TEXT_ACCOUNTANT' : 'FIRST_STEP_TEXT',
      }),
    },
  ];

  const secondStep: IStep = {
    title: intl.formatMessage({ id: 'SECOND_STEP_TITLE' }),
    text: '',
  };

  const thirdStep: IStep = {
    title: intl.formatMessage({
      id: isCalcOnly ? 'THIRD_STEP_TITLE' : 'THIRD_STEP_TITLE_AUTOMATIC',
    }),
    text: '',
  };

  if (isCalcOnly) {
    secondStep.text = intl.formatMessage({ id: 'SECOND_STEP_TEXT' });
    thirdStep.text = intl.formatMessage({ id: 'THIRD_STEP_TEXT' });

    if (isAccountant) {
      secondStep.text = intl.formatMessage({ id: 'SECOND_STEP_TEXT_ACCOUNTANT' });
      thirdStep.text = intl.formatMessage({ id: 'THIRD_STEP_TEXT_ACCOUNTANT' });
    }
  } else {
    // Calculate and make my payments automatically
    secondStep.text = intl.formatMessage({ id: 'SECOND_STEP_TEXT_AUTOMATIC' });
    thirdStep.text = intl.formatMessage({ id: 'THIRD_STEP_TEXT_AUTOMATIC' });

    if (isAccountant) {
      secondStep.text = intl.formatMessage({ id: 'SECOND_STEP_TEXT_ACCOUNTANT_AUTOMATIC' });
      thirdStep.text = intl.formatMessage({ id: 'THIRD_STEP_TEXT_ACCOUNTANT_AUTOMATIC' });
    }
  }

  steps.push(secondStep);
  steps.push(thirdStep);

  return <NextStepsView intl={intl} steps={steps} header={header} />;
};

const mapStateToProps = (state: IReducerState) => ({
  hasLoadedOptions: getHasLoadedOptions(state),
  isCalcOnly: getIsCalcOnly(state),
  isAccountant: getIsAccountant(state),
});

const mapDispatchToProps = {
  // saveStepSummary: actionSaveStepSummary,
};

export const NextSteps = injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NextStepsController),
);
